module.exports = __webpack_public_path__ + "static/media/ic-aceitar.114a4e80.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/TariffSubscribeModal/assets/ic-aceitar.svg
// module id = 1088
// module chunks = 0